import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import ContactCTABlock from './ContactCTABlock';
import '../styles/ContentPage.css';

function ContentPage({ title, body, basePath, backLabel }) {
  return (
    <div className="content-page">
      <section className="content-hero">
        <div className="content-hero-content">
          {basePath && (
            <Link to={`/${basePath}`} className="content-back-link">
              ← {backLabel || `Back to ${basePath}`}
            </Link>
          )}
          <h1>{title}</h1>
        </div>
      </section>

      <section className="content-body">
        <div className="content-container">
          <div className="content-markdown">
            <ReactMarkdown>{body}</ReactMarkdown>
          </div>
        </div>
      </section>

      <ContactCTABlock />
    </div>
  );
}

export default ContentPage;
